export default __webpack_public_path__ + "static/media/split.c1e2d134.jpeg";